import React from 'react';
import { useParams } from 'react-router-dom';
import ContactContainer from 'flow/components/contact-card/ContactContainers';
import { ContactKey } from 'flow/types/EntityKeys';

interface RouteThirdPartyContactParams {
    thirdPartyContactKey: ContactKey;
}

const RouteThirdPartyContact: React.FC = () => {
    const { thirdPartyContactKey } = useParams<RouteThirdPartyContactParams>();
    return <ContactContainer parentContactKey={thirdPartyContactKey} />;
};

export default RouteThirdPartyContact;
